/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetParkingSpotsRequest } from '../../models/get-parking-spots-request';
import { GetParkingSpotsResponse } from '../../models/get-parking-spots-response';

export interface ApiParkingSpotCmsGetParkingSpotsPost$Plain$Params {
      body?: GetParkingSpotsRequest
}

export function apiParkingSpotCmsGetParkingSpotsPost$Plain(http: HttpClient, rootUrl: string, params?: ApiParkingSpotCmsGetParkingSpotsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetParkingSpotsResponse>> {
  const rb = new RequestBuilder(rootUrl, apiParkingSpotCmsGetParkingSpotsPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetParkingSpotsResponse>;
    })
  );
}

apiParkingSpotCmsGetParkingSpotsPost$Plain.PATH = '/api/ParkingSpot/CmsGetParkingSpots';
